import React, { useEffect } from 'react';
import { AUTO_INSIGHTS_ALERTS_MORE } from '@src/utils/sensor/track';
import useDrawerState from '../Hooks/useDrawerState';
import { Insights, MoreDrawer } from './Insights';
import { OPEN_NEW_APP_VERSION_DRAWER_EVENT } from '../constants';

function NewAppVersion() {
  const { visible, openDrawer, closeDrawer } = useDrawerState({
    trackKey: AUTO_INSIGHTS_ALERTS_MORE,
  });

  // Listen for custom event to open the drawer
  useEffect(() => {
    const handleOpenDrawer = () => {
      openDrawer();
    };

    window.addEventListener(OPEN_NEW_APP_VERSION_DRAWER_EVENT, handleOpenDrawer);

    return () => {
      window.removeEventListener(OPEN_NEW_APP_VERSION_DRAWER_EVENT, handleOpenDrawer);
    };
  }, [openDrawer]);

  return (
    <>
      <Insights openMore={openDrawer} />
      <MoreDrawer visible={visible} closeMore={closeDrawer} />
    </>
  );
}

export default NewAppVersion;
